/**
 * ResponsibilityCheckbox — F-003.3 Phase 1 (IMPL-P1-002).
 * variant='full': Card con testo completo inline.
 * variant='compact': testo breve + Tooltip Radix con testo completo.
 * Accessibilità: Tooltip si apre su hover e focus (Radix default).
 */
import { Checkbox } from '@/components/ui/checkbox';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { Card, CardContent } from '@/components/ui/card';

const FULL_TEXT =
  'Dichiaro, assumendo piena responsabilità, che i dati inseriti nel presente form sono veritieri e corrispondono al contratto di locazione firmato dalle parti. Confermo di agire su mandato delle parti contraenti e che il documento PDF allegato è il contratto originale firmato.';

const COMPACT_TEXT = 'Assumo la responsabilità dei dati dichiarati';

export interface ResponsibilityCheckboxProps {
  variant: 'full' | 'compact';
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  id?: string;
}

export function ResponsibilityCheckbox({
  variant,
  checked,
  onCheckedChange,
  id = 'responsibility-checkbox',
}: ResponsibilityCheckboxProps) {
  if (variant === 'full') {
    return (
      <Card>
        <CardContent className="pt-4">
          <div className="flex items-start gap-3">
            <Checkbox
              id={id}
              checked={checked}
              onCheckedChange={(v) => onCheckedChange(v === true)}
              aria-label="Assumo la responsabilità dei dati dichiarati"
            />
            <label htmlFor={id} className="text-sm leading-relaxed cursor-pointer">
              {FULL_TEXT}
            </label>
          </div>
        </CardContent>
      </Card>
    );
  }

  // variant === 'compact'
  return (
    <TooltipProvider delayDuration={0}>
      <div className="flex items-center gap-2">
        <Checkbox
          id={id}
          checked={checked}
          onCheckedChange={(v) => onCheckedChange(v === true)}
        />
        <Tooltip>
          <TooltipTrigger asChild>
            <label
              htmlFor={id}
              className="text-sm text-muted-foreground cursor-pointer underline decoration-dotted"
            >
              {COMPACT_TEXT}
            </label>
          </TooltipTrigger>
          <TooltipContent
            side="top"
            className="max-w-xs text-xs"
            aria-label={FULL_TEXT}
          >
            {FULL_TEXT}
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
}
